<template>
  <div class="additem-step-box">
    <div class="content">
      <div class="content-box">
        <el-form :model="form" :rules="rules" ref="form" label-position="top" label-width="120px">
          <el-form-item :label="$t('dms_firmwareTask_info.ren_wu_lei_xing')" prop="serviceType">
            <custom-select v-model="form.serviceType" code="iot_cmd_task_service_type" @change="changeServiceType" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_info.ren_wu_ce_lve')" prop="taskStrategy">
            <custom-select v-model="form.taskStrategy" code="iot_cmd_task_strategy" @change="form.delayExecuteTime = ''" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_info.xie_yi_lei_bie')" prop="protocolClass">
            <custom-select v-model="form.protocolClass" code="iot_protocol_class" width="100%"></custom-select>
          </el-form-item>
          <el-form-item v-if="form.taskStrategy == 2" label prop="delayExecuteTime" :rules="form.taskStrategy == 2 ? rules.delayExecuteTime : []">
            <custom-date-picker
              style="width: 100%"
              v-model="form.delayExecuteTime"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options=" {firstDayOfWeek: 1}"
              :placeholder="$t('dms_firmwareTask_info.yszxsj')"
            ></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_info.chan_pin_xing_hao')" prop="protocolCode">
            <custom-select
              :auto="false"
              :listener="form.protocolClass"
              url="ProtocolSelectList"
              filterable
              v-model="form.protocolCode"
              :props="{ label: 'protocolDesc', value: 'protocolCode' }"
              :params="{ protocolClass: form.protocolClass }"
              @change="changeProtocol"
              width="100%"
            ></custom-select>
            <!-- <el-select
              v-model="form.protocolCode"
              @change="changeProtocol"
              style="width: 100%"
            >
              <el-option
                v-for="item in protocolList"
                :key="item.protocolCode"
                :label="item.protocolName"
                :value="item.protocolCode"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_info.TCPban_ben')" prop="tcpVersion">
            <el-select v-model="form.tcpVersion" @change="changeTcpVersion" style="width: 100%">
              <el-option v-for="item in tcpVersionList" :key="item.tcpVersion" :label="item.tcpVersion" :value="item.tcpVersion"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="topicCode" style="position: relative">
            <span slot="label">
              {{ $t('dms_firmwareTask_info.ren_wuTopic') }}
              <i style="position: absolute; right: 0px">{{ form.topicCode }}</i>
            </span>
            <el-select v-model="form.topicCode" filterable style="width: 100%" @change="changeTopicCode">
              <el-option v-for="item in topicCodeList" :key="item.topicId" :label="item.topicName" :value="item.topicCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_info.ren_wu_ming_cheng')" prop="taskName">
            <el-input v-model="form.taskName" style="width: 100%"></el-input>
          </el-form-item>
          <el-row>
            <el-form-item :label="$t('dms_firmwareTask_info.ren_wu_miao_shu')" prop="taskDesc">
              <el-input type="textarea" :row="5" v-model="form.taskDesc"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div class="btn-group">
        <el-button @click="goBack">
          {{ $t('Common.com_cancel') }}
        </el-button>
        <el-button type="primary" @click="nextVersion">
          {{ $t('dms_firmwareTask_info.xyblrzl') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    taskId: [String, Number],
  },
  watch: {
    // 切换任务类型
    'form.serviceType': function () {
      this.$emit('changeServiceType', this.form.serviceType);
      if (this.form.serviceType === '3') {
        // 3 固件升级流程
        this.nextText = this.$t('dms_firmwareTask_info.xybzybb');
      } else {
        // 其他走的是输入指令流程
        this.nextText = this.$t('dms_firmwareTask_info.xyblrzl');
      }
    },

    taskId: function () {
      if (this.taskId) {
        this.getTaskInfo();
      }
    },
  },
  data() {
    return {
      productList: [],
      protocolList: [],
      topicCodeList: [],
      tcpVersionList: [],
      form: {
        taskName: '', // 任务名称
        protocolCode: '', // 协议id
        topicCode: '', // topicCode
        topicUrl: '', // topicUrl
        topicId: '', // topicId 第二步用
        topicType: '', // 只有第一步要传
        tcpTopicCode: '', // 只有第一步要传
        tcpVersion: '', // 只有第一步要传
        serviceType: '', // 任务类型
        taskStrategy: '', // 任务策略
        protocolClass: '', // 协议类别
        delayExecuteTime: '', // 延迟执行时间
        taskDesc: '', // 任务描述
        taskId: '', // 任务id
        topicDesc: '',
        controlMode: '', // topicCode 关联设备1单个2多个
        commandMode: '', //  1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择
      },
      nextText: '',
    };
  },
  mounted() {
    this.getDictionary('iot_topic_type', (data) => {
      const iotTopicType = data.iot_topic_type;
      const item = iotTopicType.find(i => i.code === 'pub');
      this.form.topicType = item.value;
    });
    if (this.taskId) {
      // 编辑
      this.getTaskInfo();
    }
    // this.getProductList();
  },

  computed: {
    rules() {
      return {
        taskName: [
          {
            max: 100,
            message: this.$t('Common.com_rules_length_max', [100]),
          },
        ],
        protocolCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        serviceType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        protocolClass: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        tcpVersion: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        topicCode: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        taskStrategy: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        delayExecuteTime: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    // 编辑情况下获取任务详情
    getTaskInfo() {
      this.$getJSON(`${apis.commandTaskDevice}/${this.taskId}`).then((res) => {
        this.$setFormatData(this.form, res.data);
        this.form.serviceType = `${res.data.serviceType}`;
        this.form.taskStrategy = `${res.data.taskStrategy}`;
        this.form.tcpVersion = `${res.data.tcpVersion}`;

        // 获取下拉
        // this.getProtocolList(true);

        this.getiotTopicList();
        this.getTcpVersionList(true);
      });
    },
    // 根据产品查协议
    getProtocolList: function (isInit) {
      this.$getJSON(apis.ProtocolSelectList, { productCode: this.form.productCode }).then((res) => {
        this.protocolList = res.data;
        if (this.protocolList.length === 1) {
          this.form.protocolCode = this.protocolList[0].protocolCode;
          this.getTcpVersionList(isInit);
        }
      });
    },
    // TopiclistProductCode
    // 协议切换
    changeProtocol: function () {
      this.form.tcpVersion = '';
      this.getTcpVersionList();
    },
    getTcpVersionList: function (isInit) {
      this.$getJSON(apis.protocolPublishTcpVersionSelectList, {
        protocolCode: this.form.protocolCode,
      }).then((res) => {
        this.tcpVersionList = res.data;
        if (this.tcpVersionList.length && !this.form.tcpVersion) {
          this.form.tcpVersion = this.tcpVersionList[0].tcpVersion;
          this.changeTcpVersion(isInit);
        }
      });
    },
    changeTcpVersion(isInit) {
      if (!isInit) {
        this.form.topicCode = '';
      }
      this.getiotTopicList();
    },
    changeServiceType() {
      this.form.topicCode = '';
      this.getiotTopicList();
    },
    // 根据协议查topic
    getiotTopicList: function () {
      // `${apis.TopiclistprotocolCode}/${this.form.protocolCode}`
      this.$getJSON(apis.TopicPublishSelectList, {
        protocolCode: this.form.protocolCode,
        // topicType: 3,
        protocolClass: this.form.protocolClass,
        tcpVersion: this.form.tcpVersion,
        serviceType: this.form.serviceType,
      }).then((res) => {
        this.topicCodeList = res.data;
        // 如果是编辑 同步TopicId(第二步查物模型时候用)
        if (this.taskId) {
          this.syncTopicId();
        }
      });
    },
    changeTopicCode: function (topicCode) {
      const item = this.topicCodeList.find(i => i.topicCode === topicCode) || {};
      this.form.tcpTopicCode = item.tcpTopicCode;
      // this.form.tcpVersion = item.tcpVersion;
      this.form.topicUrl = item.topicUrl;
      this.form.topicId = item.topicId;
      this.form.topicDesc = item.topicDesc || '';
      this.form.controlMode = item.controlMode;
      this.form.commandMode = item.commandMode;
      if (this.taskId) {
        this.$emit('syncTopicId', this.taskId, this.form.serviceType, this.form.commandMode, this.form);
        // this.form.tcpVersion = tcpVersion;
      }
    },
    // 同步TopicId
    syncTopicId: function () {
      this.changeTopicCode(this.form.topicCode, this.form.tcpVersion);
    },
    goBack: function () {
      this.jump('/iot/firmwareTask');
    },

    nextVersion: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        if (!this.form.taskName) {
          const topic = this.topicCodeList.find(item => item.topicCode === this.form.topicCode);
          this.form.taskName = topic.topicName;
        }

        if (this.taskId) {
          this.$postJSON(apis.commandTaskUpdate, this.form, true).then(() => {
            const taskId = this.taskId;
            // 任务类型
            const serviceType = this.form.serviceType;
            this.$emit('success', taskId, serviceType, this.form.commandMode, this.form);
          });
        } else {
          this.$postJSON(apis.commandTaskAdd, this.form, true).then((res) => {
            const taskId = res.data;
            // 任务类型
            const serviceType = this.form.serviceType;
            this.$emit('success', taskId, serviceType, this.form.commandMode, this.form);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.additem-step-box {
  display: flex;
  height: 100%;
  background-color: #ffffff;
  flex-direction: column;
}
</style>
